import { FunctionComponent, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useFlagEmissionsCapability } from '../hooks/use-flag-emissions-capability';

/**
 * Protects FLAG-only routes: redirects when the organisation has FLAG disabled.
 * Use as a wrapper around page components or route elements.
 */
export const FlagEmissionsRoute: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { flagEnabled } = useFlagEmissionsCapability();
  if (!flagEnabled) {
    return <Navigate to='/dashboard' replace />;
  }
  return <>{children}</>;
};
